import { IHelpContextRepository } from "@/core/repositories/helpContext";
import { LocalStorageAdapter } from "@/infrastructure/adapters/localStorage";

export class HelpContextRepository implements IHelpContextRepository {
  private readonly IS_FIRST_TIME_PAGE_KEY = "isFirstDeductionPage";
  private readonly IS_FIRST_TIME_DEDUCTION_SUB_TYPE_HELP_TEXT_DISPLAYED_KEY = "isFirstTimeDeductionSubTypeHelpTextDisplayed";

  constructor(private readonly storage: LocalStorageAdapter) {}

  async setIsFirstDeductionPage(isFirstTimePage: boolean): Promise<void> {
    await this.storage.store({
      key: this.IS_FIRST_TIME_PAGE_KEY,
      value: isFirstTimePage,
    });
  }

  async isFirstDeductionPage(): Promise<boolean> {
    const item = await this.storage.retrieve<boolean>(this.IS_FIRST_TIME_PAGE_KEY);
    return item?.value ?? false;
  }

  async setIsFirstTimeDeductionSubTypeHelpTextDisplayed(isFirstTimeDeductionSubTypeHelpTextDisplayed: boolean): Promise<void> {
    await this.storage.store({
      key: this.IS_FIRST_TIME_DEDUCTION_SUB_TYPE_HELP_TEXT_DISPLAYED_KEY,
      value: isFirstTimeDeductionSubTypeHelpTextDisplayed,
    });
  }
  
  async isFirstTimeDeductionSubTypeHelpTextDisplayed(): Promise<boolean> {
    const item = await this.storage.retrieve<boolean>(this.IS_FIRST_TIME_DEDUCTION_SUB_TYPE_HELP_TEXT_DISPLAYED_KEY);
    return item?.value ?? false;
  }
}
